export const API_URLS = {
  SIGN_IN: '/v1/auth/local/sign-in',
  ACCOUNT: '/v4/account',
  GET_CODE_BY_EMAIL: '/v2/common/otp',
  PASSWORD_RESTORE: '/v1/auth/password/restore',
  UPDATE_TOKEN: '/v1/auth/update-token',
  VERIFY_OTP_AUTH: '/v1/common/otp/auth',
  GET_PROFILE: '/v1/view/personal-payment-plan-page',
  UNSUBSCRIBE_MEALS: '/v1/payment/upsale/meals/unsubscribe',
  UNSUBSCRIBE_HUBSPOT: '/v1/payment/hubspot/unsubscribe',
}
